module.exports = __webpack_public_path__ + "img/icone_excel.8fc4c3bc.png";